import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IWohaCardLinkProps } from "./WohaCardLink.props";
export const WohaCardLink = ({ children, className, link }: IWohaCardLinkProps) => {
  const classes = cn(
    "group block rounded-xl border border-ash bg-white transition-[border-color,background-color,transform] duration-200 ease-out",
    link &&
      "hover:-translate-y-0.5 hover:border-smoke focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-blue",
    className,
  );
  if (!link) return <article className={classes}>{children}</article>;
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={link.accessibilityLabel || undefined}
      className={classes}
      href={link.href}
      rel={link.openInNewTab ? "noopener noreferrer" : undefined}
      target={link.openInNewTab ? "_blank" : undefined}
    >
      {children}
    </Link>
  );
};
WohaCardLink.displayName = "Content::WohaCardLink";
